/**
 * Grid-slider: Slick slider syncing via asNavFor (https://kenwheeler.github.io/slick/)
 */
(function () {
    const GALLERY = 'media-gallery[data-presentation="grid_slider"]';

    let lastLayoutMode = null;
    let resizeTimer;

    function isMobile() {
      return window.innerWidth < 768;
    }

    function maxThumbVisible() {
      const w = window.innerWidth;
      if (w > 1440) return 6;
      if (w >= 1280) return 5;
      if (w >= 1024) return 4;
      if (w >= 768) return 5;
      return 3;
    }

    function getLayoutMode() {
      return `${isMobile() ? 'mobile' : 'desktop'}-${maxThumbVisible()}`;
    }

    function setThumbVisibleVar(gallery) {
      gallery.style.setProperty('--thumb-visible', String(maxThumbVisible()));
    }
  
    function whenReady(callback) {
      if (typeof $ !== 'undefined' && $.fn.slick) {
        callback();
        return;
      }
  
      let attempts = 0;
      const timer = setInterval(() => {
        if (typeof $ !== 'undefined' && $.fn.slick) {
          clearInterval(timer);
          callback();
        } else if (++attempts > 40) {
          clearInterval(timer);
        }
      }, 25);
    }
  
    function visibleThumbCount(slideCount) {
      return Math.min(slideCount, maxThumbVisible());
    }
  
    function thumbIsScrollable(thumbCount) {
      return thumbCount > maxThumbVisible();
    }
  
    function getThumbCount($thumb) {
      if (!$thumb.length) return 0;
      if ($thumb.hasClass('slick-initialized')) {
        return $thumb.slick('getSlick').slideCount;
      }
      return $thumb.children('.thumbnail-item').length;
    }
  
    function getResumeIndex(gallery) {
      const index = Number(gallery.dataset.resumeSlide);
      return Number.isFinite(index) ? index : 0;
    }
  
    function clearResumeIndex(gallery) {
      delete gallery.dataset.resumeSlide;
    }
  
    function storeResumeIndex(gallery) {
      const $main = $(gallery).find('.product-main-slider');
      if ($main.hasClass('slick-initialized')) {
        gallery.dataset.resumeSlide = String($main.slick('slickCurrentSlide'));
      }
    }
  
    function syncThumbHighlight($thumb, index) {
      if (!$thumb.hasClass('slick-initialized')) return;

      $thumb.find('.thumb-image').removeClass('is-active');
      $thumb.find('.slick-slide').removeClass('slick-current slick-active').attr('aria-hidden', 'true');
      $thumb
        .find('.slick-slide')
        .filter(function () {
          return Number($(this).attr('data-slick-index')) === index;
        })
        .first()
        .addClass('slick-current slick-active')
        .attr('aria-hidden', 'false')
        .find('.thumb-image')
        .addClass('is-active');
    }
  
    function goToSyncedIndex($main, $thumb, index, scrollable) {
      if (!$main.hasClass('slick-initialized')) return;
  
      $main.slick('slickGoTo', index, false);
  
      if (!$thumb.hasClass('slick-initialized')) return;
  
      if (scrollable) {
        $thumb.slick('slickGoTo', index, false);
      } else {
        syncThumbHighlight($thumb, index);
      }
    }
  
    function bindMainToThumbHighlight($main, $thumb) {
      $main.off('afterChange.gridSlider');
      $main.on('afterChange.gridSlider', function (_event, _slick, currentSlide) {
        syncThumbHighlight($thumb, currentSlide);
      });
      syncThumbHighlight($thumb, $main.slick('slickCurrentSlide'));
    }
  
    function setGalleryState(gallery, state) {
      gallery.classList.toggle('is-slider-pending', state === 'pending');
      gallery.classList.toggle('is-slider-ready', state === 'ready');
      gallery.classList.toggle('is-slider-mobile', state === 'ready' && isMobile());
      gallery.classList.toggle('is-slider-desktop', state === 'ready' && !isMobile());
    }
  
    function unslickAll($main, $thumb, $wrapper) {
      $main.off('afterChange.gridSlider afterChange.gridSliderArrows');
      if ($thumb.hasClass('slick-initialized')) $thumb.slick('unslick');
      if ($main.hasClass('slick-initialized')) $main.slick('unslick');
      $wrapper[0]?.style.removeProperty('--thumb-visible');
    }
  
    function getMainOptions(scrollable, $thumb) {
      return {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: false,
        infinite: false,
        waitForAnimate: false,
        swipe: true,
        draggable: true,
        touchMove: true,
        speed: 300,
        cssEase: 'ease',
        asNavFor: scrollable ? $thumb : null,
      };
    }
  
    function getThumbOptions($main, $wrapper, thumbCount, visible, scrollable) {
      if (isMobile()) {
        $wrapper[0]?.style.setProperty('--thumb-visible', String(visible));
  
        return {
          slidesToShow: visible,
          slidesToScroll: 1,
          asNavFor: $main,
          focusOnSelect: true,
          infinite: false,
          arrows: scrollable,
          dots: false,
          vertical: false,
          draggable: scrollable,
          swipe: scrollable,
          waitForAnimate: false,
          appendArrows: $wrapper,
        };
      }
  
      return {
        slidesToShow: visible,
        slidesToScroll: 1,
        asNavFor: $main,
        focusOnSelect: true,
        infinite: false,
        arrows: scrollable,
        dots: false,
        vertical: true,
        verticalSwiping: scrollable,
        draggable: scrollable,
        swipe: scrollable,
        adaptiveHeight: false,
        waitForAnimate: false,
      };
    }
  
    function bindMainArrows(gallery) {
      if (gallery.dataset.mainArrowsBound === 'true') return;
      gallery.dataset.mainArrowsBound = 'true';

      gallery.addEventListener('click', (event) => {
        const control = event.target.closest(
          '.product-main-slider-wrapper .slideshow-control--previous, .product-main-slider-wrapper .slideshow-control--next'
        );
        if (!control || control.classList.contains('is-disabled')) return;

        const $main = $(gallery).find('.product-main-slider');
        if (!$main.hasClass('slick-initialized')) return;

        event.preventDefault();
        event.stopPropagation();

        if (control.classList.contains('slideshow-control--previous')) {
          $main.slick('slickPrev');
        } else {
          $main.slick('slickNext');
        }
      });
    }

    function syncMainArrowState(gallery, $main) {
      if (!$main.hasClass('slick-initialized')) return;

      const slick = $main.slick('getSlick');
      const current = slick.currentSlide;
      const last = slick.slideCount - 1;
      const prev = gallery.querySelector('.product-main-slider-arrow.slideshow-control--previous');
      const next = gallery.querySelector('.product-main-slider-arrow.slideshow-control--next');

      if (prev) {
        const disabled = current <= 0;
        prev.classList.toggle('is-disabled', disabled);
        prev.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      }

      if (next) {
        const disabled = current >= last;
        next.classList.toggle('is-disabled', disabled);
        next.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      }
    }

    function bindMainArrowState(gallery, $main) {
      $main.off('afterChange.gridSliderArrows');
      $main.on('afterChange.gridSliderArrows', function () {
        syncMainArrowState(gallery, $main);
      });
      syncMainArrowState(gallery, $main);
    }
  
    function bindZoomSync(gallery, $main, $thumb) {
      const zoomDialog = gallery.querySelector('zoom-dialog');
      if (!zoomDialog || zoomDialog.dataset.sliderSyncBound === 'true') return;
  
      zoomDialog.dataset.sliderSyncBound = 'true';
      zoomDialog.addEventListener('zoom-media:selected', (event) => {
        const index = event.detail?.index;
        if (index == null) return;
        goToSyncedIndex($main, $thumb, index, thumbIsScrollable(getThumbCount($thumb)));
      });
    }
  
    function refreshSliderLayout($main, $thumb) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if ($main.hasClass('slick-initialized')) {
            $main.slick('setPosition');
          }
          if ($thumb.hasClass('slick-initialized')) {
            $thumb.slick('setPosition');
          }
        });
      });
    }
  
    function initGallery(gallery) {
      if (typeof $ === 'undefined' || !$.fn.slick) return false;
  
      const initId = (gallery.dataset.sliderInitId = String(Number(gallery.dataset.sliderInitId || 0) + 1));
      const resumeIndex = getResumeIndex(gallery);
  
      const $main = $(gallery).find('.product-main-slider');
      const $wrapper = $(gallery).find('.product-thumbnails-wrapper');
      const $thumb = $(gallery).find('.product-thumbnails-slider');
      if (!$main.length) return false;

      setThumbVisibleVar(gallery);
      setGalleryState(gallery, 'pending');
      unslickAll($main, $thumb, $wrapper);
  
      if (gallery.dataset.sliderInitId !== initId) return false;
  
      const mainCount = $main.children('.main-slide-item').length;
      const thumbCount = $thumb.children('.thumbnail-item').length;
      const hasThumbs = thumbCount > 1 && $thumb.length;

      if (mainCount <= 1) {
        clearResumeIndex(gallery);
        gallery.dataset.layoutMode = getLayoutMode();
        setGalleryState(gallery, 'ready');
        return true;
      }
  
      if (!hasThumbs) {
        $main.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          arrows: false,
          dots: false,
          fade: false,
          swipe: true,
          draggable: true,
          touchMove: true,
          speed: 300,
          cssEase: 'ease',
          waitForAnimate: false,
        });
  
        if (resumeIndex > 0) {
          $main.slick('slickGoTo', Math.min(resumeIndex, mainCount - 1), false);
        }
  
        bindMainArrows(gallery);
        bindMainArrowState(gallery, $main);
        clearResumeIndex(gallery);
        gallery.dataset.layoutMode = getLayoutMode();
        setGalleryState(gallery, 'ready');
        refreshSliderLayout($main, $thumb);
        return true;
      }
  
      const visible = visibleThumbCount(thumbCount);
      const scrollable = thumbIsScrollable(thumbCount);
  
      $main.slick(getMainOptions(scrollable, $thumb));
  
      if (gallery.dataset.sliderInitId !== initId) return false;
  
      $thumb.slick(getThumbOptions($main, $wrapper, thumbCount, visible, scrollable));
  
      if (!scrollable) {
        bindMainToThumbHighlight($main, $thumb);
      }
  
      if (gallery.dataset.sliderInitId !== initId) return false;
  
      const targetIndex = Math.min(resumeIndex, mainCount - 1);
      if (targetIndex > 0) {
        goToSyncedIndex($main, $thumb, targetIndex, scrollable);
      }
  
      bindMainArrows(gallery);
      bindMainArrowState(gallery, $main);
      bindZoomSync(gallery, $main, $thumb);
      clearResumeIndex(gallery);
      gallery.dataset.layoutMode = getLayoutMode();
      setGalleryState(gallery, 'ready');
      refreshSliderLayout($main, $thumb);
      return true;
    }
  
    window.reInitProductSlider = function () {
      whenReady(() => {
        document.querySelectorAll(GALLERY).forEach((gallery) => {
          initGallery(gallery);
        });
        lastLayoutMode = getLayoutMode();
      });
    };
  
    function scheduleLayoutReinit() {
      clearTimeout(resizeTimer);
      document.querySelectorAll(GALLERY).forEach((gallery) => {
        storeResumeIndex(gallery);
        setGalleryState(gallery, 'pending');
      });
      resizeTimer = setTimeout(window.reInitProductSlider, 80);
    }
  
    function handleResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        const mode = getLayoutMode();

        if (lastLayoutMode !== null && mode !== lastLayoutMode) {
          lastLayoutMode = mode;
          scheduleLayoutReinit();
          return;
        }

        lastLayoutMode = mode;

        document.querySelectorAll(GALLERY).forEach((gallery) => {
          setThumbVisibleVar(gallery);
          if (!gallery.classList.contains('is-slider-ready')) return;

          const $main = $(gallery).find('.product-main-slider');
          const $thumb = $(gallery).find('.product-thumbnails-slider');
          refreshSliderLayout($main, $thumb);
        });
      }, 120);
    }
  
    document.addEventListener('variant:update', function () {
      document.querySelectorAll(GALLERY).forEach(storeResumeIndex);
      requestAnimationFrame(() => requestAnimationFrame(scheduleLayoutReinit));
    });
  
    window.addEventListener('resize', handleResize);
  
    function boot() {
      document.querySelectorAll(GALLERY).forEach(setThumbVisibleVar);
      lastLayoutMode = getLayoutMode();
      window.reInitProductSlider();
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  
    document.addEventListener('shopify:section:load', scheduleLayoutReinit);
  })();
  